import React, {Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from   '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import OKIcon from '@material-ui/icons/CheckCircleOutlined';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },

  redCell: {
    color: 'red',
  },

    content: {
	backgroundColor: 'white',
	opacity: '1',
  },
  
});

class PopupMessage extends Component {
	constructor(props) {
		super(props);
		this.handleClose = this.handleClose.bind(this);
    }

  handleClose(e){
	e.preventDefault();
	 this.props.onClosePopup(e);
  }

  render() {
    const { classes } = this.props;
		let { t } = this.props;
    return (
	<div >
			<Dialog style={{textAlign: "center"}}
			open 
			fullScreen={this.props.fullScreen} 
            onClose={this.handleClose}
			PaperProps ={{
				classes: {
				 root: classes.content
				}
			  }}
			>
			<DialogTitle >{this.props.title}</DialogTitle>
			<DialogContent>
			{this.props.error &&
				<DialogContentText className={classes.redCell}>
				{this.props.text}
				</DialogContentText>
			}	
			{!this.props.error &&
				<DialogContentText>
					<Typography color='primary' variant='subheading' style={{whiteSpace: 'pre-line', textAlign: "left"}}>
					{this.props.text}
					</Typography>
				</DialogContentText>
			}	
			</DialogContent>
			<DialogActions style={{display: 'flex', justifyContent: 'center'}}>
			  <Button  color="primary" onClick={this.handleClose} >
				<OKIcon/>&nbsp;{t('ok.button')}
			  </Button>
			</DialogActions>
		  </Dialog>
    </div>
    );
  }  
	
}
export default  withTranslation()(withStyles(styles)(PopupMessage));  
